
export default function FormWrapper({ children, currentStep, loading }){
    return (
      <div className="form-wrapper" style={{position: "relative"}} >

        {/* <span className="form-step" >Step {currentStep + 1} of 3</span>&nbsp;&nbsp;     */}
        {loading == true &&
          <span  style={{position: "absolute", left: "70px", backgroundColor: "#eee"}} className="form-loading">Loading...</span>
        }
        {/* <button type="button" className="prev-btn" onClick={goToPreviousStep} disabled={!canGoBack}>Back</button>*/}
        
        <div>
          {children}          
        </div>

      </div>
    );
}